import {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  MouseEventHandler,
  ReactNode,
} from "react";
import { UrlObject } from "url";

export enum BUTTON_SIZE {
  XLARGE = "xlarge",
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
}

export enum BUTTON_COLOR {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  DANGER = "danger",
  SUCCESS = "success",
  NEUTRAL = "neutral",
  WARNING = "warning",
}

export enum BUTTON_VARIANT {
  FILL = "fill",
  OUTLINE = "outline",
  TEXT = "text",
  GHOST = "ghost",
  TEXT_ACTION = "text_action",
}

export enum BUTTON_STATUS {
  DEFAULT = "default",
  HOVER = "hover",
  SELECTED = "selected",
  DISABLE = "disable",
  LOADING = "loading",
}

export type ButtonDetailedHTMLProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export interface BaseProps {
  variant?: BUTTON_VARIANT;
  color?: BUTTON_COLOR;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  className?: string;
  isLoading?: boolean;
  children?: ReactNode;
  fullWidth?: boolean;
  sizes?: ResponsiveSizes;
  size?: BUTTON_SIZE;
}

export interface LinkComponentProps
  extends BaseProps,
    Omit<ButtonDetailedHTMLProps, "color" | "href"> {
  href: UrlObject | string;
  target?: string;
  linkClassName?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export interface ButtonComponentProps
  extends BaseProps,
    Omit<ButtonDetailedHTMLProps, "color"> {
  href?: undefined;
  linkClassName?: string;
}

type Breakpoint = "default" | "sm" | "md" | "lg" | "xl" | "2xl";

export type ResponsiveSizes = Partial<Record<Breakpoint, BUTTON_SIZE>>;

export type ButtonProps = LinkComponentProps | ButtonComponentProps;
